import React, { PropsWithChildren } from 'react';

import { FadeWrapper } from 'components/shared/FadeWrapper';
import Loader from 'components/shared/Loader';

import { Props } from './types';

function SceneLoaderWrapper({ children, loading = false }: PropsWithChildren<Props>) {
  return (
    <>
      <FadeWrapper isShow={loading}>
        <Loader isFillBlock />
      </FadeWrapper>

      {children}
    </>
  );
}

export { SceneLoaderWrapper };
